import { createStructuredSelector } from 'reselect';

import { getViewport } from 'app/redux/globals/selectors';

const Selectors = createStructuredSelector({
  viewport: getViewport,
});

export default Selectors;



// WEBPACK FOOTER //
// ./src/redux/ui/home/selectors.js